import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import {Button,ButtonToolbar} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import PrintButtons from '../../../component/element/PrintButtons'
import HrStore from '../../../stores/HrStore';
import AlertPopup from '../../../component/element/AlertPopup'
import AlertPopupStore from '../../../component/element/AlertPopupStore'
import TextFieldModal from '../../../component/element/TextFieldModal'
import IframeModal from '../../../component/element/IframeModal'
import SlipContractorDetail from '../slip/SlipContractorDetail'
import CkSlipPeriod from '../../../component/element/CkSlipPeriod'
import SlipEditPopup from '../slip/SlipEditPopup'
import ConfirmPopup from 'component/element/ConfirmPopup'
import withSizes from 'react-sizes';
import ReportMobileTable from '../../report/ReportMobileTable'

// import {connect} from 'react-redux';
var NotificationSystem = require('react-notification-system')
var numberFormat = require('number-format.js')

Number.prototype.formatMoney = function (c, d, t) {
  var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

const mockWageList = new Array(3).fill(null).map((val) => {
  return {
    brand: Math.random().toString(36).substring(7),
    carRegistrationNo: Math.random().toString(36).substring(7),
    description: `เหลือ   เหมา \n เบิก xxxxx จำนวน 555 บาท \n เบิก xxxxx จำนวน 555 บาท \n i don't know  `,
    owner_name: Math.random().toString(36).substring(5),
    // amount: Math.floor(Math.random() * 30000 + 1),
    amount: '300000',
    withdraw: '55',    
    balance: '77',
    receivedBy: ''
  }
})

const dataFromAPI = {
  wageList: mockWageList,
  summary: {
    subsidiaryAmount: '8888000',
    parentAmount: '5000'
  }
}

const DESCRIPTION_FIELD = 'description'
const AMOUNT_FIELD = 'amount'
const WITHDRAW_FIELD = 'withdraw'
const BALANCE_FIELD = 'balance'

class ReportContractorWage extends Component {

  constructor(...args) {
    super(...args)
    this.hrConfig = {}
    this.slipPeriod = []
    this.allowEdit = [DESCRIPTION_FIELD,AMOUNT_FIELD,WITHDRAW_FIELD]
    this.state = {    
      showPeriod:false,  
      showTable:false,
      loading:false,
      activePerson:null,
      slip:{},
      slipPeriod:[],hrConfig:null,periodState:{},
      data: {
        wageList: [],
        summary: {
          subsidiaryAmount: '0',
          parentAmount: '0'
        }
      },
      tableList:[],
      dataSlipDetail:{},
      dataSlip:[],
      showWithdrawDelete:false,
      info:{slip_no:'',employee_id:'',periodic:''}
    }
    this.refTableId  = 'slipContrTable-'+Math.ceil(Math.random()*100); 
  }

  componentDidMount(){
    this.setState({showPeriod:true})
  }

  onInitPeriod(periodState){
    this.setState({periodState:periodState})
    let {year,month,rangeValue} = periodState
    //this.loadNetworkData(year,month,rangeValue)

    
    HrStore.loadSlipConfigPeriod(year,month,(result)=>{
      this.slipConfig = result.data    
      this.pdfTemplate = result.pdf_template
      //console.log('slipConfig',that.slipConfig,that.hrConfig)
      this.setState({hrConfig:result.hr_config,slipPeriod:result.slip_period})
      //resolve({that:that,newOption:newOption})
    },(error)=>{
      
    })
  }

  loadNetworkData(year,month,option){
    this.setState({loading:true})
    let loadConfig = function(that){
     let promise = new Promise(function (resolve, reject) {     
        HrStore.loadSlipConfigPeriod(year,month,function(result){
          that.slipConfig = result.data    
          that.hrConfig = result.hr_config  
          that.slipPeriod = result.slip_period
          //console.log('slipConfig',that.slipConfig,that.hrConfig)
          let options = that.getWeekDayOnMonth(year,month)
          let newOption  = that.getCurrentRange(options,new Date());
          //console.log('newSlip',year,month,newOption,options)
          that.setState({options:options,week:newOption})
          resolve({that:that,newOption:newOption})
        },function(error){
          reject(error) 
        })
     })
     return promise
    }

    let loadAllSlip = function(self){
      let promise = new Promise(function (resolve, reject) {
        
        self.that.loadAllSlip(year,month,self.newOption,reject)
      })
      return promise
    }

    loadConfig(this)
    .then(loadAllSlip)
    .catch(error=>{
      //console.log('error:',error)
      this.setState({loading:false,statusText:error.desc})
    })
  }

  loadAllSlip(year,month,option,reject){
    let {showTable,activePerson} = this.state
    let that = this
    this.setState({loading:true})
    HrStore.loadAllSlipContractor(year,month,option,function(result){
      that.setState({tableList:result.data,loading:false})
      if(showTable){
        //finding same employee and fetch new data
        let foundItem = result.data.find(item => {
          return (item.employee_id===activePerson.employee_id)
        });        

        if(foundItem!==undefined){
          that.onRowClick(foundItem)
        }else{
          //Clear table
          activePerson.slip_no = ''
          that.setState({activePerson:activePerson})
        }
      }
    },function(error){
      if(typeof reject!=='undefined')
        reject(error)            
    })          
  
  
  }



  replaceAll (result,find, replace) {
    //var result = this;
    do {
        var split = result.split(find);
        result = split.join(replace);
    } while (split.length > 1);
    return result;
  }

  onDetailRowClick(index,key,value){
    let {data} = this.state
    let {wageList} = data

    if(this.allowEdit.includes(key)){
      let componentClass = (key===DESCRIPTION_FIELD)?'textarea':'input'
      let infoValue = wageList[index][key]
      if(key===DESCRIPTION_FIELD){
        var newline = String.fromCharCode(13, 10);
        infoValue = this.replaceAll(infoValue,'\\n', newline);
      }
      let fieldInfo = {title:'ใส่ข้อมูล',componentClass:componentClass,showClear:true,row:index,key:key,value:infoValue}
      this.refs.textFieldModal.loadInfo(fieldInfo)
    }
  }

  onTextFieldSave(fieldInfo){
    let {data} = this.state
    let {wageList} = data

    wageList[fieldInfo.row][fieldInfo.key] = fieldInfo.value
    this.setState({data:data})


    //Post to API
  }

  onEmployeeIdClick(emId){
    if (process.env.NODE_ENV == "development") {
      alert('click->'+emId)
    }else{      
      window.show_employee_doc(emId);
    }
  }
  

  onSlipContractorPrintClick(){
    let {periodState,activePerson} = this.state   
    let {rangeValue,year,month} = periodState
    
    let slipId = activePerson.slip_no
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportContractorWageSlip&slipList='+slipId+'&year='+year+'&month='+month+'&week='+rangeValue.value
    } else{
      url = './pdf/v2/?startPage=PrintReportContractorWageSlip&slipList='+slipId+'&year='+year+'&month='+month+'&week='+rangeValue.value
    }
    this.refs.iframe.loadUrl(url)
  }

  onSlipPeriodChange(periodState){
    this.setState({periodState:periodState})
    
    let {year,month,rangeValue} = periodState
    this.loadAllSlip(year,month,rangeValue)
  }

  formatValue(row, key) {
    // row: array of obj
    // key: obj key
    const val = row[key]
    if (key === DESCRIPTION_FIELD){
      return this.addLineBreak(val)
    }
    if (isNaN(val) || val === '')
      return val
    return parseInt(val).formatMoney(0)
  }

  getRangeText(){
    let {periodState} = this.state
    let {rangeValue,year} = periodState

    let betweenTitle = (rangeValue!==undefined)?(rangeValue.label + ' ' + year):''
    return betweenTitle
  }

  renderBody() {
    // const wageList = this.addBrToDescription()
    const wageList = this.state.data.wageList
    return wageList.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"
        return <td className={tdClass} onClick={this.onDetailRowClick.bind(this,index,key,formattedValue)} key={kid + 1}>{formattedValue}</td>
      })

      // add id column to array of <td>
      const tdWithIds = [<td key={0} className="text-center" >{index + 1}</td>].concat(tds)
      return <tr key={index}>{tdWithIds}</tr>
    })
  }

  


  toInteger(val) {
    // if input has typo, reset to zero
    return isNaN(val) ? 0 : parseInt(val)
  }

  onData(slips,datas,info) { 
    this.setState({dataSlip:slips,dataSlipDetail:datas,info:info})
  }  

  onWithdrawDelete() {
    this.setState({showWithdrawDelete:true})
  }

  onConfirmWithdrawDelete() {
    let {dataSlip,dataSlipDetail,info} = this.state
    dataSlip.wageList.forEach((item,index)=>{
      if (item.withdraw==0||item.withdraw=='0'||item.withdraw=='') {
        let postData = {employee_id:info.employee_id,work_no:dataSlip.wageList[index].work_no,periodic:info.periodic}
        HrStore.deleteContractorWithdraw(postData,(result)=>{
          if (result.status=='OK') {
            delete dataSlip.wageList[index]
            delete dataSlipDetail.income[index]
            this.setState({showWithdrawDelete:false})
          }
        },()=>{
          this.setState({showWithdrawDelete:false})
        })  
      }   
    })
    let wageList = []
    dataSlip.wageList.forEach((item,index)=>{
      wageList.push(item)
    })
    let income = []
    dataSlipDetail.income.map((item,index)=>{
      income.push(item)
    })
    dataSlip.wageList = wageList
    dataSlipDetail.income = income
    this.setState({showWithdrawDelete:false})
  }

  renderTable(){
    let {showTable,activePerson} = this.state
    const mechanicName = (activePerson)?activePerson.first_name+' ('+activePerson.nick_name+') - '+activePerson.position:''
    const slipId = (activePerson)?activePerson.slip_no:''
    return (
      <div>
        <SlipContractorDetail 
        show={showTable} 
        mechanicName={mechanicName} 
        slipId={slipId} 
        onBackClick={this.onBackClick.bind(this)}
        onData={this.onData.bind(this)}
        />
      </div>
    )
  }

  
  getSummary(key) {
    let {tableList} = this.state
    let sum = 0
    tableList.forEach((item,index)=>{
      sum = parseInt(item[key]) + parseInt(sum)
    })
    return numberFormat("#,##0.#",sum)
  }


  renderPrintButton(){
    let {showTable} = this.state

    if(showTable){
      return (
        <div style={{width:'550px',display:'inline-block',marginLeft:'0'}}>
            <ButtonToolbar>
              <Button bsStyle={null} className='bg-maroon' onClick={this.onSlipContractorPrintClick.bind(this)}><FontAwesome name='print'/>{' '}พิมพ์สลิป</Button>
              <Button bsStyle={'danger'} onClick={this.onWithdrawDelete.bind(this)}><FontAwesome name='trash'/>{' '}ลบรายการที่ไม่ได้เบิก</Button>              
            </ButtonToolbar>           
          </div>
      )
    }else{
      return (
          <PrintButtons
          width={''}
          createTableTitle='สร้างตารางสลิป'
          onCreateTable={this.onCreateTable.bind(this)}
          onPrintSlipDetail={this.onPrintSlipDetail.bind(this)}
          onPrintSlip={this.onPrintSlip.bind(this)}
          onPrintTable={this.onPrintTable.bind(this)}
          onExportExcel={this.onExportExcel.bind(this)}     
          marginLeft={'0'}     
        />
      )
    }
  }

  renderToolbar() {
    let {hrConfig,slipPeriod,showPeriod} = this.state
    return (
      <div style={{marginBottom:'5px'}}>
        <CkSlipPeriod 
          show={showPeriod}
          hrConfig={hrConfig} 
          slipPeriod={slipPeriod} 
          onInitPeriod={this.onInitPeriod.bind(this)}
          onChange={this.onSlipPeriodChange.bind(this)}
        />
        {this.renderPrintButton()}
      </div>
    )
  }

  

  onRowClick(person){
    this.setState({showTable:true,activePerson:person})
    //this.loadContractorSlipDetail(person.slip_no)
  }

  onCreateTable(e) {
    // do sth
    let that = this
    let {periodState,tableList} = this.state
    let {rangeValue,year,month,options} = periodState

    let title = 'ต้องการจะออกสลิปสำหรับช่างเหมา?'
    
    AlertPopupStore.confirm(title,'ยืนยัน',function(){
      that.setState({loading:true})
      
        HrStore.newSlipContractor(year,month,rangeValue,options,function(result){
          that.setState({loading:false,tableList:result.data})
        },function(error){
          // console.log('error',error)
          that.setState({loading:false,tableList:[]})
          that.refs.notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'สร้างตารางไม่สำเร็จ',
            level: 'error',
            position: 'tc',        
          });
        })
      
    })
  }

  onPrintSlip(){
    
    let {year,month,rangeValue} = this.state.periodState
    let {emType} = this.props
    let emId = 8;
    let periodic = HrStore.getPeriodic(year,month,rangeValue.value)

    if(this.pdfTemplate.PrintSalarySlipDoc !==undefined){
      if (process.env.NODE_ENV == "development") {
        window.open('./?startPage='+this.pdfTemplate.PrintSalarySlipDoc+'&periodic=' + periodic + '&em_type='+emId, '_blank');
      }else{
        window.open('./pdf/v2/?startPage='+this.pdfTemplate.PrintSalarySlipDoc+'&periodic=' + periodic + '&em_type='+emId, '_blank');
      }
    }else{
      if (process.env.NODE_ENV == "development") {
          window.open('https://demo2.bigfix.co/korat/pdf/?periodic=' + periodic + '&file=allslip_doc&em_type='+emId, '_blank');
      }else{
          window.open('./pdf/?periodic=' + periodic + '&file=allslip_doc&em_type='+emId, '_blank');
      }
    } 
  }


  onPrintSlipDetail(e) {
    let {tableList,option,periodState} = this.state
    let {rangeValue,year,month} = periodState
    let slipId = ''
    tableList.forEach(function(item,index) {
      let q = ','
      if (index===tableList.length-1)
        q = ''

      slipId += item.slip_no+q
    })

    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportContractorWageSlip&slipList='+slipId+'&year='+year+'&month='+month+'&week='+rangeValue.value
    } else{
      url = './pdf/v2/?startPage=PrintReportContractorWageSlip&slipList='+slipId+'&year='+year+'&month='+month+'&week='+rangeValue.value
    }
    this.refs.iframe.loadUrl(url)
  }

  onPrintTable(e) {
    let {option,periodState} = this.state
    let {rangeValue,year,month} = periodState
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportContractorWageTable&year='+year+'&month='+month+'&week='+rangeValue.value
    } else{
      url = './pdf/v2/?startPage=PrintReportContractorWageTable&year='+year+'&month='+month+'&week='+rangeValue.value
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcel(e) {
    // do sth
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    // let wb = new Workbook()
    // wb.SheetNames.push('worksheet')
    // wb.Sheets['worksheet'] = worksheet
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }

    const {year,rangeValue} = this.state.periodState       
    const fileName = 'รายงานช่างเหมาประจำวันที่ '+this.getRangeText()+".xlsx"
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
  }

  

  onBackClick(refresh){
    this.state.showTable = false
    this.setState({showTable:false})

    if(refresh){
      let {periodState} = this.state
      let {year,month,rangeValue} = periodState
      this.loadAllSlip(year,month,rangeValue)
    }
  }

  onContractorSelect(person){
    this.setState({activePerson:person})
    this.loadWageDetail(person.contractor_id)
  }


  onSlipEditAbsenceClose(changeFlag,afterCloseFunc){
    //this.onAbsenceClose(changeFlag,afterCloseFunc)
  }

  onSlipEditAbsence(loadAbsence){
      let {tableList,periodState,editRow} = this.state
      let {rangeValue,year,month} = periodState
      // console.log('editRow',editRow)

      // loadAbsence(tableList[editRow][EM_ID_INDEX],rangeValue,this.getRangeText())
  }

  onEditPopup(){
    this.setState({show:false,editRow:''})
    let {emType} = this.props
    let {year,month,rangeValue} = this.state.periodState, that = this

    //this.loadAllSlipWage(emType,year,month,rangeValue)
  }

  onColumnClick(row){
    // console.log('row',row)
    // let {emType} = this.props
    let {tableList,periodState} = this.state
    // let {year,month,rangeValue} = periodState
    // let disableFields = []
       
    let slipId = row.slip_no
    this.refs.slipEditPopup.loadSlipInfo(slipId);
    this.setState({show:true,slipId:slipId,editRow:row})
  
  }
  
  renderRowData(){
    let {tableList} = this.state
    if(tableList.length===0){
      return (<tr><td colSpan={12}>ไม่พบข้อมูล...</td></tr>)
    }
    return tableList.map((item,index)=>(
      <tr key={index}>        
        <td  onClick={this.onColumnClick.bind(this,item)}>{item.slip_no}</td>
        <td  onClick={this.onEmployeeIdClick.bind(this,item.employee_id)}>{item.employee_id}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.first_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.last_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.nick_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)} >{item.position}</td>
        <td  className='text-right'  onClick={this.onRowClick.bind(this,item)} >{numberFormat("#,##0.#",item.income_fixing)}</td>
        <td  className='text-right'  onClick={this.onRowClick.bind(this,item)} >{numberFormat("#,##0.#",item.total_withdraw)}</td>
        <td  className='text-right'  onClick={this.onRowClick.bind(this,item)} >{numberFormat("#,##0.#",item.income_other)}</td>
        <td  className='text-right'  onClick={this.onRowClick.bind(this,item)} >{numberFormat("#,##0.#",item.total_deduction)}</td>  
        <td style={{backgroundColor:'#e7e7e7',color:'#d9534f'}} className='text-right'  onClick={this.onRowClick.bind(this,item)} >{numberFormat("#,##0.#",item.net_income)}</td>
        <td  className='text-right'  onClick={this.onRowClick.bind(this,item)} >{numberFormat("#,##0.#",item.net_payable)}</td>        
      </tr>
    )) 
  }

  renderSlipTable(){
    return (
      <div className='table-responsive'>
        <table id={this.refTableId} className='table table-hover table-bordered-solid' style={{marginBottom:'0',minWidth:'1280px'}}>
          <thead>
            <tr>
              <th>เลขสลิป</th>
              <th>รหัสพนักงาน</th>
              <th>ชื่อ</th>
              <th>นามสกุล</th>   
              <th>ชื่อเล่น</th>            
              <th>ตำแหน่ง</th>
              <th>รายได้เหมาซ่อม</th>
              <th>เบิกจ่าย</th>
              <th>รายได้อื่นๆ</th>
              <th>รายหักทั้งหมด</th>
              <th style={{backgroundColor:'#d9534f'}}>คงเหลือจ่ายจริง</th>
              <th>คงเหลือค้างจ่าย</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={6}>รวมค่าแรงช่างเหมา</th>
              <th className='text-right'>{this.getSummary('income_fixing')}</th>
              <th className='text-right'>{this.getSummary('total_withdraw')}</th>
              <th className='text-right'>{this.getSummary('income_other')}</th>
              <th className='text-right'>{this.getSummary('total_deduction')}</th>
              <th style={{color:'#d9534f'}} className='text-right'>{this.getSummary('net_income')}</th>
              <th className='text-right'>{this.getSummary('net_payable')}</th>
            </tr>
          </tfoot>
        </table>
      </div>  
    )
  }
  
  renderContractorList(){
    let {showTable} = this.state
    return (
      <div style={{display:(!showTable)?'block':'none'}}>
        {this.renderSlipTable()}
      </div>
    )
  }

  onMobileRowClick(item,items) {
    this.onRowClick(items) 
  }

  renderMobileTable(){
    let {tableList,showTable} = this.state
    let fieldMap = {title:'fullname',amount:'net_payable',sub_title:'slip_no',date:'employee_id',status:5,sub_status:''}
    let _data = []
    _data = tableList.map((item,index)=>{
      let _item = item
      _item = Object.assign({fullname:item.first_name+' '+item.last_name}, _item)
      return _item
    })
    return(
      <div style={{display:(!showTable)?'block':'none'}}>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'slip_no'}
          onRowClick={this.onMobileRowClick.bind(this)}
        />
      </div>
    )
  }

  render() {
    const {loading,slipId,show} = this.state    
    let {isMobile} = this.props
    const titile = 'รายงาน'
    const reportDateText = this.getRangeText()
    return (
      <Box loading={loading}>
        <Box.Header border={true}>
          <Box.Title>{titile} ประจำวันที่ {reportDateText}</Box.Title>
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {isMobile?this.renderMobileTable():this.renderContractorList()}
          {this.renderTable()}
          <SlipEditPopup ref='slipEditPopup' 
            show={show} 
            slipId={slipId}              
            pdfTemplate={this.pdfTemplate}
            onEditAbsence={this.onSlipEditAbsence.bind(this)}           
            onCloseAbsence={this.onSlipEditAbsenceClose.bind(this)}
            onHide={this.onEditPopup.bind(this)}/>
          <AlertPopup />
          <NotificationSystem ref="notificationSystem" /> 
          <TextFieldModal ref='textFieldModal' maxLength="200" rows={10} onConfirm={this.onTextFieldSave.bind(this)}/>
          <IframeModal ref='iframe' title='พิมพ์เอกสาร'/>    
          <ConfirmPopup
            show={this.state.showWithdrawDelete}
            message={'ต้องการลบข้อมูลที่ไม่ได้เบิกออกจากรายการสลิปนี้หรือไม่ ?'}
            onHide={()=>{this.setState({showWithdrawDelete:false})}}
            onConfirm={this.onConfirmWithdrawDelete.bind(this)}
          />
        </Box.Body>
      </Box>
    )
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default ReportContractorWage = withSizes(mapSizesToProps)(ReportContractorWage);



// WEBPACK FOOTER //
// ./src/view/hr/report/ReportContractorWage.js